// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.PersonalInfoPage_personal-info__LNfrK {
  width: 100%;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
@media (max-width: 820px) {
  .PersonalInfoPage_personal-info__LNfrK .PersonalInfoPage_status-toast-wrapper__DyPgl {
    display: none;
  }
}
.PersonalInfoPage_personal-info__layout__O3Ihv {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) 300px;
  gap: 24px;
  align-items: start;
}
@media (max-width: 1100px) {
  .PersonalInfoPage_personal-info__layout__O3Ihv {
    grid-template-columns: 1fr;
  }
}
.PersonalInfoPage_personal-info__content__yrUTp {
  min-width: 0;
}
@media (max-width: 1100px) {
  .PersonalInfoPage_personal-info__content__yrUTp {
    grid-row: 2;
  }
}
.PersonalInfoPage_personal-info__aside__88J9I {
  position: sticky;
  top: 94px;
}
@media (max-width: 1100px) {
  .PersonalInfoPage_personal-info__aside__88J9I {
    position: static;
    margin-top: 0;
    grid-row: 1;
  }
}
.PersonalInfoPage_personal-info__actions__ezIUG {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin: 8px 0 16px;
}
.PersonalInfoPage_personal-info__edit-trigger__Ezkii {
  appearance: none;
  background: #82B194;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 14px;
  font-weight: 800;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s ease;
}
.PersonalInfoPage_personal-info__edit-trigger__Ezkii:hover {
  background: #739F84;
}
@media (max-width: 820px) {
  .PersonalInfoPage_personal-info__edit-trigger__Ezkii {
    width: 100%;
    padding: 14px 20px;
    font-size: 14px;
  }
}

.PersonalInfoPage_content-card__yNB-G {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.05);
  border-radius: 28px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  padding: 28px 28px 32px;
}
@media (max-width: 820px) {
  .PersonalInfoPage_content-card__yNB-G {
    padding: 20px 16px 24px;
    border-radius: 20px;
  }
}
.PersonalInfoPage_content-card__title-block__ALBQ3 h2 {
  margin: 0 0 20px;
  font-size: 28px;
  line-height: 1.06;
  letter-spacing: -0.04em;
  font-weight: 800;
}

.PersonalInfoPage_section-block__p0gTP + .PersonalInfoPage_section-block__p0gTP {
  margin-top: 24px;
  border-top: 1px solid rgba(16, 25, 21, 0.07);
}
.PersonalInfoPage_section-block__heading__Ae\\+oR {
  margin: 0 0 24px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.PersonalInfoPage_grid-2__pdmoe {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}
@media (max-width: 600px) {
  .PersonalInfoPage_grid-2__pdmoe {
    grid-template-columns: 1fr;
  }
}

.PersonalInfoPage_grid-address__1vrSN {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px;
  gap: 24px;
  margin-top: 24px;
}
@media (max-width: 600px) {
  .PersonalInfoPage_grid-address__1vrSN {
    grid-template-columns: 1fr;
  }
}

.PersonalInfoPage_field__Ld3qk {
  display: grid;
  gap: 10px;
}
.PersonalInfoPage_field__label__zXacq {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #6e897c;
}
.PersonalInfoPage_field__Ld3qk .MuiInputBase-root {
  min-height: 50px !important;
  background: #ffffff !important;
  border-radius: 16px !important;
  font-size: 14px !important;
}
.PersonalInfoPage_field__Ld3qk .MuiInputBase-root .PersonalInfoPage_MuiOutlinedInput-notchedOutline__92dMu {
  border-color: rgba(21, 36, 30, 0.08) !important;
}
.PersonalInfoPage_field__input__cYwx9 {
  min-height: 50px;
  background: #FFFFFF;
  border: 1px solid rgba(21, 36, 30, 0.08);
  border-radius: 16px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #13231D;
  font-weight: 600;
}

.PersonalInfoPage_side-photo__bPZVW {
  display: grid;
  gap: 16px;
}
@media (max-width: 1100px) {
  .PersonalInfoPage_side-photo__bPZVW {
    justify-items: center;
    text-align: center;
    margin-bottom: 16px;
  }
}
.PersonalInfoPage_side-photo__frame__yF0Ed {
  width: 176px;
  aspect-ratio: 4/5;
  border-radius: 30px;
  padding: 6px;
  background: #FFFFFF;
  box-shadow: 0 8px 20px rgba(18, 34, 28, 0.06);
  position: relative;
}
.PersonalInfoPage_side-photo__img-container__OSSQa {
  width: 100%;
  height: 100%;
  border-radius: 24px;
  overflow: hidden;
  background-color: #F1EEE8;
  background-size: cover;
  background-position: center;
}
.PersonalInfoPage_side-photo__edit-btn__p8V04 {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: #82B194;
  color: #fff;
  border: none;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 14px rgba(18, 34, 28, 0.12);
  cursor: pointer;
}
.PersonalInfoPage_side-photo__meta__szdUl h3 {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 800;
}
.PersonalInfoPage_side-photo__meta__szdUl p {
  margin: 0;
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
  line-height: 1.55;
  max-width: 28ch;
}

.PersonalInfoPage_save-bar__KvQOa {
  position: sticky;
  bottom: 20px;
  z-index: 10;
  margin-top: 32px;
  padding-top: 12px;
}
.PersonalInfoPage_save-bar__pill__yC5gr {
  min-height: 74px;
  border-radius: 24px;
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.05);
  box-shadow: 0 10px 18px rgba(18, 34, 28, 0.1);
  background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%);
  transition: background 0.3s ease;
}
.PersonalInfoPage_save-bar__pill--green__HKkNx {
  background: linear-gradient(90deg, #DCEADF 0%, #EAF3ED 28%, #F7F5F1 52%, #F7F5F1 100%);
}
.PersonalInfoPage_save-bar__pill__yC5gr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  gap: 14px;
}
@media (max-width: 820px) {
  .PersonalInfoPage_save-bar__pill__yC5gr {
    flex-direction: column;
    height: auto;
    padding: 16px;
  }
}
.PersonalInfoPage_save-bar__state__Epnl6 {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.PersonalInfoPage_save-bar__dot__JmXy1 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #D6A640; /* gold */
  margin-top: 6px;
  transition: background-color 0.3s ease;
}
.PersonalInfoPage_save-bar__dot--green__XRiMr {
  background: #82B194;
}
.PersonalInfoPage_save-bar__dot--saved__MNhQh {
  background-color: rgba(19, 35, 29, 0.18);
}
.PersonalInfoPage_save-bar__copy__ygyoS {
  font-size: 13px;
  font-weight: 800;
  color: #13231D;
}
.PersonalInfoPage_save-bar__sub__RRFFo {
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
}
.PersonalInfoPage_save-bar__actions__S\\+0wU {
  display: flex;
  gap: 10px;
}
@media (max-width: 820px) {
  .PersonalInfoPage_save-bar__actions__S\\+0wU {
    width: 100%;
  }
}

.PersonalInfoPage_save-cta__vk0mq {
  min-width: 148px;
  min-height: 42px;
  border-radius: 14px;
  background: #82B194;
  color: #fff;
  border: none;
  font-weight: 800;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s;
}
.PersonalInfoPage_save-cta__vk0mq:hover {
  background: #739F84;
}
@media (max-width: 820px) {
  .PersonalInfoPage_save-cta__vk0mq {
    width: 100%;
  }
}

.PersonalInfoPage_btn-secondary__ffqKJ {
  min-height: 40px;
  padding: 0 18px;
  border-radius: 14px;
  background: transparent;
  border: 1px solid rgba(130, 177, 148, 0.4);
  color: #13231D;
  font-weight: 800;
  cursor: pointer;
  min-width: 108px;
  font-size: 13px;
}
@media (max-width: 820px) {
  .PersonalInfoPage_btn-secondary__ffqKJ {
    width: 100%;
  }
}

.PersonalInfoPage_acceptance-card__Miqtu {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid rgba(16, 25, 21, 0.07);
}
.PersonalInfoPage_acceptance-card__Miqtu.PersonalInfoPage_has-error__\\+t2Kh {
  border-color: rgba(140, 79, 67, 0.38);
  box-shadow: 0 0 0 3px rgba(140, 79, 67, 0.06);
}

.PersonalInfoPage_acceptance-copy__sg0\\+N {
  display: grid;
  gap: 14px;
  max-width: 760px;
  margin-bottom: 20px;
}
.PersonalInfoPage_acceptance-copy__sg0\\+N p {
  margin: 0;
  color: #4F5F59;
  font-size: 13px;
  line-height: 1.68;
}
.PersonalInfoPage_acceptance-copy__sg0\\+N p strong {
  color: #13231D;
  font-weight: 700;
}

.PersonalInfoPage_acceptance-check__E6WDT {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 18px;
  border: 1px solid rgba(16, 25, 21, 0.08);
  background: #FBFBF8;
  cursor: pointer;
  transition: border-color 0.2s ease;
}
.PersonalInfoPage_acceptance-check__E6WDT input {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  accent-color: #82B194;
  flex: 0 0 18px;
  cursor: pointer;
}
.PersonalInfoPage_acceptance-check__E6WDT span {
  font-size: 13.5px;
  line-height: 1.55;
  font-weight: 650;
  color: #13231D;
}

.PersonalInfoPage_acceptance-help__yvpNr {
  margin: 12px 0 0;
  color: rgba(19, 35, 29, 0.68);
  font-size: 12px;
  line-height: 1.6;
}

.PersonalInfoPage_acceptance-error__\\+0Pzm {
  margin: 10px 0 0;
  color: #8C4F43;
  font-size: 12px;
  line-height: 1.55;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/pages/PersonalInfoPage/PersonalInfoPage.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACI,WAAA;EACA,oFDEQ;ACeZ;AAdQ;EADJ;IAEQ,aAAA;EAiBV;AACF;AAdI;EACI,aAAA;EACA,6CAAA;EACA,SAAA;EACA,kBAAA;AAgBR;AAdQ;EANJ;IAOQ,0BAAA;EAiBV;AACF;AAdI;EACI,YAAA;AAgBR;AAfQ;EAFJ;IAGQ,WAAA;EAkBV;AACF;AAfI;EACI,gBAAA;EACA,SAAA;AAiBR;AAfQ;EAJJ;IAKQ,gBAAA;IACA,aAAA;IACA,WAAA;EAkBV;AACF;AAfI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,kBAAA;AAiBR;AAdI;EACI,gBAAA;EACA,mBDxCe;ECyCf,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AAgBR;AAdQ;EACI,mBDlDW;ACkEvB;AAbQ;EAhBJ;IAiBQ,WAAA;IACA,kBAAA;IACA,eAAA;EAgBV;AACF;;AAZA;EACI,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,2CDXU;ECYV,uBAAA;AAeJ;AAbI;EAPJ;IAQQ,uBAAA;IACA,mBAAA;EAgBN;AACF;AAdI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAgBR;;AAXI;EACI,gBAAA;EACA,4CAAA;AAcR;AAXI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAaR;;AATA;EACI,aAAA;EACA,gDAAA;EACA,SAAA;AAYJ;AAVI;EALJ;IAMQ,0BAAA;EAaN;AACF;;AAVA;EACI,aAAA;EACA,2CAAA;EACA,SAAA;EACA,gBAAA;AAaJ;AAXI;EANJ;IAOQ,0BAAA;EAcN;AACF;;AAXA;EACI,aAAA;EACA,SAAA;AAcJ;AAZI;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAcR;AAXI;EACI,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0BAAA;AAaR;AAXQ;EACI,+CAAA;AAaZ;AATI;EACI,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cDzIe;EC0If,gBAAA;AAWR;;AAPA;EACI,aAAA;EACA,SAAA;AAUJ;AARI;EAJJ;IAKQ,qBAAA;IACA,kBAAA;IACA,mBAAA;EAWN;AACF;AATI;EACI,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;AAWR;AARI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,2BAAA;AAUR;AAPI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBDhMe;ECiMf,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;AASR;AALQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;AAOZ;AAJQ;EACI,SAAA;EACA,eAAA;EACA,6BDpMW;ECqMX,iBAAA;EACA,eAAA;AAMZ;;AADA;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAIJ;AAFI;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,6CAAA;EACA,sFAAA;EACA,gCAAA;AAIR;AAFQ;EACI,sFAAA;AAIZ;AAdI;EAYI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,SAAA;AAKR;AAHQ;EAlBJ;IAmBQ,sBAAA;IACA,YAAA;IACA,aAAA;EAMV;AACF;AAHI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AAKR;AAFI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA,EAAA,SAAA;EACA,eAAA;EACA,sCAAA;AAIR;AAFQ;EACI,mBDzQW;AC6QvB;AADQ;EACI,wCAAA;AAGZ;AACI;EACI,eAAA;EACA,gBAAA;EACA,cDvQe;ACwQvB;AAEI;EACI,eAAA;EACA,6BD1Qe;AC0QvB;AAGI;EACI,aAAA;EACA,SAAA;AADR;AAGQ;EAJJ;IAKQ,WAAA;EAAV;AACF;;AAIA;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBD1SmB;EC2SnB,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AADJ;AAGI;EACI,mBDlTe;ACiTvB;AAII;EAhBJ;IAiBQ,WAAA;EADN;AACF;;AAIA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,cDpTmB;ECqTnB,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAGI;EAZJ;IAaQ,WAAA;EAAN;AACF;;AAGA;EACI,gBAAA;EACA,iBAAA;EACA,4CAAA;AAAJ;AAEI;EACI,qCAAA;EACA,6CAAA;AAAR;;AAIA;EACI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAGI;EACI,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AADR;AAGQ;EACI,cDvVW;ECwVX,gBAAA;AADZ;;AAMA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;AAHJ;AAKI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBDzXe;EC0Xf,cAAA;EACA,eAAA;AAHR;AAMI;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDrXe;ACiXvB;;AAQA;EACI,gBAAA;EACA,6BDzXmB;EC0XnB,eAAA;EACA,gBAAA;AALJ;;AAQA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AALJ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n.personal-info {\n    width: 100%;\n    font-family: $font-main;\n\n    .status-toast-wrapper {\n        @media (max-width: 820px) {\n            display: none;\n        }\n    }\n\n    &__layout {\n        display: grid;\n        grid-template-columns: minmax(0, 1.6fr) 300px;\n        gap: 24px;\n        align-items: start;\n\n        @media (max-width: 1100px) {\n            grid-template-columns: 1fr;\n        }\n    }\n\n    &__content {\n        min-width: 0;\n        @media (max-width: 1100px) {\n            grid-row: 2;\n        }\n    }\n\n    &__aside {\n        position: sticky;\n        top: 94px;\n\n        @media (max-width: 1100px) {\n            position: static;\n            margin-top: 0;\n            grid-row: 1;\n        }\n    }\n\n    &__actions {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 12px;\n        margin: 8px 0 16px;\n    }\n\n    &__edit-trigger {\n        appearance: none;\n        background: $color-primary;\n        color: #fff;\n        border: none;\n        padding: 10px 20px;\n        border-radius: 14px;\n        font-weight: 800;\n        cursor: pointer;\n        font-size: 13px;\n        transition: background 0.2s ease;\n\n        &:hover {\n            background: $color-primary-hover;\n        }\n\n        @media (max-width: 820px) {\n            width: 100%;\n            padding: 14px 20px;\n            font-size: 14px;\n        }\n    }\n}\n\n.content-card {\n    background: #F7F5F1;\n    border: 1px solid rgba(16, 25, 21, 0.05);\n    border-radius: 28px;\n    box-shadow: $shadow-card;\n    padding: 28px 28px 32px;\n\n    @media (max-width: 820px) {\n        padding: 20px 16px 24px;\n        border-radius: 20px;\n    }\n\n    &__title-block h2 {\n        margin: 0 0 20px;\n        font-size: 28px;\n        line-height: 1.06;\n        letter-spacing: -0.04em;\n        font-weight: 800;\n    }\n}\n\n.section-block {\n    &+& {\n        margin-top: 24px;\n        border-top: 1px solid rgba(16, 25, 21, 0.07);\n    }\n\n    &__heading {\n        margin: 0 0 24px;\n        font-size: 16px;\n        font-weight: 800;\n        letter-spacing: -0.02em;\n    }\n}\n\n.grid-2 {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 24px;\n\n    @media (max-width: 600px) {\n        grid-template-columns: 1fr;\n    }\n}\n\n.grid-address {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 140px;\n    gap: 24px;\n    margin-top: 24px;\n\n    @media (max-width: 600px) {\n        grid-template-columns: 1fr;\n    }\n}\n\n.field {\n    display: grid;\n    gap: 10px;\n\n    &__label {\n        font-size: 11px;\n        font-weight: 800;\n        letter-spacing: 0.14em;\n        text-transform: uppercase;\n        color: #6e897c;\n    }\n\n    :global(.MuiInputBase-root) {\n        min-height: 50px !important;\n        background: #ffffff !important;\n        border-radius: 16px !important;\n        font-size: 14px !important;\n\n        .MuiOutlinedInput-notchedOutline {\n            border-color: rgba(21, 36, 30, 0.08) !important;\n        }\n    }\n\n    &__input {\n        min-height: 50px;\n        background: #FFFFFF;\n        border: 1px solid rgba(21, 36, 30, 0.08);\n        border-radius: 16px;\n        padding: 0 16px;\n        display: flex;\n        align-items: center;\n        font-size: 14px;\n        color: $text-main;\n        font-weight: 600;\n    }\n}\n\n.side-photo {\n    display: grid;\n    gap: 16px;\n\n    @media (max-width: 1100px) {\n        justify-items: center;\n        text-align: center;\n        margin-bottom: 16px;\n    }\n\n    &__frame {\n        width: 176px;\n        aspect-ratio: 4 / 5;\n        border-radius: 30px;\n        padding: 6px;\n        background: #FFFFFF;\n        box-shadow: 0 8px 20px rgba(18, 34, 28, 0.06);\n        position: relative;\n    }\n\n    &__img-container {\n        width: 100%;\n        height: 100%;\n        border-radius: 24px;\n        overflow: hidden;\n        background-color: #F1EEE8;\n        background-size: cover;\n        background-position: center;\n    }\n\n    &__edit-btn {\n        position: absolute;\n        right: -2px;\n        bottom: -2px;\n        width: 34px;\n        height: 34px;\n        border-radius: 12px;\n        background: $color-primary;\n        color: #fff;\n        border: none;\n        display: grid;\n        place-items: center;\n        box-shadow: 0 6px 14px rgba(18, 34, 28, 0.12);\n        cursor: pointer;\n    }\n\n    &__meta {\n        h3 {\n            margin: 0 0 6px;\n            font-size: 17px;\n            font-weight: 800;\n        }\n\n        p {\n            margin: 0;\n            font-size: 12px;\n            color: $text-secondary;\n            line-height: 1.55;\n            max-width: 28ch;\n        }\n    }\n}\n\n.save-bar {\n    position: sticky;\n    bottom: 20px;\n    z-index: 10;\n    margin-top: 32px;\n    padding-top: 12px;\n\n    &__pill {\n        min-height: 74px;\n        border-radius: 24px;\n        background: #F7F5F1;\n        border: 1px solid rgba(16, 25, 21, 0.05);\n        box-shadow: 0 10px 18px rgba(18, 34, 28, 0.10);\n        background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%);\n        transition: background 0.3s ease;\n\n        &--green {\n            background: linear-gradient(90deg, #DCEADF 0%, #EAF3ED 28%, #F7F5F1 52%, #F7F5F1 100%);\n        }\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 12px 16px;\n        gap: 14px;\n\n        @media (max-width: 820px) {\n            flex-direction: column;\n            height: auto;\n            padding: 16px;\n        }\n    }\n\n    &__state {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    &__dot {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        background: #D6A640; /* gold */\n        margin-top: 6px;\n        transition: background-color 0.3s ease;\n\n        &--green {\n            background: $color-primary;\n        }\n\n        &--saved {\n            background-color: rgba(19, 35, 29, 0.18);\n        }\n    }\n\n    &__copy {\n        font-size: 13px;\n        font-weight: 800;\n        color: $text-main;\n    }\n\n    &__sub {\n        font-size: 12px;\n        color: $text-secondary;\n    }\n\n    &__actions {\n        display: flex;\n        gap: 10px;\n\n        @media (max-width: 820px) {\n            width: 100%;\n        }\n    }\n}\n\n.save-cta {\n    min-width: 148px;\n    min-height: 42px;\n    border-radius: 14px;\n    background: $color-primary;\n    color: #fff;\n    border: none;\n    font-weight: 800;\n    cursor: pointer;\n    font-size: 13px;\n    transition: background 0.2s;\n\n    &:hover {\n        background: $color-primary-hover;\n    }\n\n    @media (max-width: 820px) {\n        width: 100%;\n    }\n}\n\n.btn-secondary {\n    min-height: 40px;\n    padding: 0 18px;\n    border-radius: 14px;\n    background: transparent;\n    border: 1px solid rgba(130, 177, 148, 0.4);\n    color: $text-main;\n    font-weight: 800;\n    cursor: pointer;\n    min-width: 108px;\n    font-size: 13px;\n\n    @media (max-width: 820px) {\n        width: 100%;\n    }\n}\n\n.acceptance-card {\n    margin-top: 30px;\n    padding-top: 30px;\n    border-top: 1px solid rgba(16, 25, 21, 0.07);\n\n    &.has-error {\n        border-color: rgba(140, 79, 67, 0.38);\n        box-shadow: 0 0 0 3px rgba(140, 79, 67, 0.06);\n    }\n}\n\n.acceptance-copy {\n    display: grid;\n    gap: 14px;\n    max-width: 760px;\n    margin-bottom: 20px;\n\n    p {\n        margin: 0;\n        color: #4F5F59;\n        font-size: 13px;\n        line-height: 1.68;\n\n        strong {\n            color: $text-main;\n            font-weight: 700;\n        }\n    }\n}\n\n.acceptance-check {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 16px 20px;\n    border-radius: 18px;\n    border: 1px solid rgba(16, 25, 21, 0.08);\n    background: #FBFBF8;\n    cursor: pointer;\n    transition: border-color 0.2s ease;\n\n    input {\n        width: 18px;\n        height: 18px;\n        margin-top: 2px;\n        accent-color: $color-primary;\n        flex: 0 0 18px;\n        cursor: pointer;\n    }\n\n    span {\n        font-size: 13.5px;\n        line-height: 1.55;\n        font-weight: 650;\n        color: $text-main;\n    }\n}\n\n.acceptance-help {\n    margin: 12px 0 0;\n    color: $text-secondary;\n    font-size: 12px;\n    line-height: 1.6;\n}\n\n.acceptance-error {\n    margin: 10px 0 0;\n    color: #8C4F43;\n    font-size: 12px;\n    line-height: 1.55;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"personal-info": `PersonalInfoPage_personal-info__LNfrK`,
	"status-toast-wrapper": `PersonalInfoPage_status-toast-wrapper__DyPgl`,
	"personal-info__layout": `PersonalInfoPage_personal-info__layout__O3Ihv`,
	"personal-info__content": `PersonalInfoPage_personal-info__content__yrUTp`,
	"personal-info__aside": `PersonalInfoPage_personal-info__aside__88J9I`,
	"personal-info__actions": `PersonalInfoPage_personal-info__actions__ezIUG`,
	"personal-info__edit-trigger": `PersonalInfoPage_personal-info__edit-trigger__Ezkii`,
	"content-card": `PersonalInfoPage_content-card__yNB-G`,
	"content-card__title-block": `PersonalInfoPage_content-card__title-block__ALBQ3`,
	"section-block": `PersonalInfoPage_section-block__p0gTP`,
	"section-block__heading": `PersonalInfoPage_section-block__heading__Ae+oR`,
	"grid-2": `PersonalInfoPage_grid-2__pdmoe`,
	"grid-address": `PersonalInfoPage_grid-address__1vrSN`,
	"field": `PersonalInfoPage_field__Ld3qk`,
	"field__label": `PersonalInfoPage_field__label__zXacq`,
	"MuiOutlinedInput-notchedOutline": `PersonalInfoPage_MuiOutlinedInput-notchedOutline__92dMu`,
	"field__input": `PersonalInfoPage_field__input__cYwx9`,
	"side-photo": `PersonalInfoPage_side-photo__bPZVW`,
	"side-photo__frame": `PersonalInfoPage_side-photo__frame__yF0Ed`,
	"side-photo__img-container": `PersonalInfoPage_side-photo__img-container__OSSQa`,
	"side-photo__edit-btn": `PersonalInfoPage_side-photo__edit-btn__p8V04`,
	"side-photo__meta": `PersonalInfoPage_side-photo__meta__szdUl`,
	"save-bar": `PersonalInfoPage_save-bar__KvQOa`,
	"save-bar__pill": `PersonalInfoPage_save-bar__pill__yC5gr`,
	"save-bar__pill--green": `PersonalInfoPage_save-bar__pill--green__HKkNx`,
	"save-bar__state": `PersonalInfoPage_save-bar__state__Epnl6`,
	"save-bar__dot": `PersonalInfoPage_save-bar__dot__JmXy1`,
	"save-bar__dot--green": `PersonalInfoPage_save-bar__dot--green__XRiMr`,
	"save-bar__dot--saved": `PersonalInfoPage_save-bar__dot--saved__MNhQh`,
	"save-bar__copy": `PersonalInfoPage_save-bar__copy__ygyoS`,
	"save-bar__sub": `PersonalInfoPage_save-bar__sub__RRFFo`,
	"save-bar__actions": `PersonalInfoPage_save-bar__actions__S+0wU`,
	"save-cta": `PersonalInfoPage_save-cta__vk0mq`,
	"btn-secondary": `PersonalInfoPage_btn-secondary__ffqKJ`,
	"acceptance-card": `PersonalInfoPage_acceptance-card__Miqtu`,
	"has-error": `PersonalInfoPage_has-error__+t2Kh`,
	"acceptance-copy": `PersonalInfoPage_acceptance-copy__sg0+N`,
	"acceptance-check": `PersonalInfoPage_acceptance-check__E6WDT`,
	"acceptance-help": `PersonalInfoPage_acceptance-help__yvpNr`,
	"acceptance-error": `PersonalInfoPage_acceptance-error__+0Pzm`
};
export default ___CSS_LOADER_EXPORT___;
